import { Component, Inject, OnInit } from "@angular/core";
import { AppService } from "src/_services/app.service";
import { ActivatedRoute, Router } from "@angular/router";
import { OperatorData } from 'src/_models/operators';
import { OperatorConfigList } from 'src/_constants/operator';
import { MAT_DIALOG_DATA, MatDialog } from "@angular/material";

@Component({
  selector: "app-create-operators",
  templateUrl: "./create-operators.component.html",
  styleUrls: ["./create-operators.component.scss"],
})


export class CreateOperatorsComponent implements OnInit {
  private currency: string[];
  private status: string[];
  private operator: OperatorData;
  private walletType: string[]
  groupNames = [];
  searchKey = "";
  searchFeed = "";
  feedNames = [];
  LobbyNames = ["Exchange","SportBook"]
  private ConfigData: any;
  Partner: Array<{ PartnerId: string, Status: string, Currency: string, Rate: number, Commisssion: number }> = [];
  AddPluseShow: boolean = false;
  OpConfigList = OperatorConfigList;

  constructor(
    private appService: AppService,
    private router: Router,
    private activetedRoute: ActivatedRoute,
    public dialog: MatDialog,
  ) { }

  ngOnInit() {
    this.activetedRoute.queryParams.subscribe((params) => {
      this.groupNames = params["list"];
      this.feedNames = params["fgList"]
    });
    this.status = ["ACTIVE", "BLOCKED"];
    this.walletType = ["Feed", "Seamless", "Transfer"]
    this.currency = ["INR", "HKD", "USD"]

    this.operator = new OperatorData({
      operatorId: "", operatorName: "", operatorKey: "", baseURL: "", group: "", feedGroup: "", Status: this.status[0], walletType: this.walletType[2], Currency: this.currency[0], Commisssion: "", AddSubFields: true,
      betFairPlus: false,
      tommyPlus: false,
      srPlus: false,
      rxPlus: false,
      mzPlus: false,
      signature: false,
      marketResult: false,
      newSession: false,
      showBalance: false,
      cashout: false,
      betupdate: false,
      exposure: false,
      maxExposure: 0,
      noCommission: false,
      isSdk: false,
      Dream: false,
      Tommy: false,
      BetFair: false,
      SportRadar: false,
      RX: false,
      MZ: false,
      version: 0,
      moUrl: "",
      bmUrl: "",
      fancyUrl: "",
      premiumUrl: "",
      moTopic: "",
      bmTopic: "",
      fancyTopic: "",
      premiumTopic: "",
      betUpdatesURL: "",
      Lobby: "",
      advMO: 0,
      limitId: 0
    });

    this.ConfigData = {
      hold: 0, matchOdds: { delay: 0, maxOdds: 0, min: 0, max: 0 },
      bookmaker: { delay: 0,  min: 0, max: 0 },
      fancy: { delay: 0, min: 0, max: 0 },
      isSet: true
    };

    this.Partner = [{
      PartnerId: "",
      Status: "ACTIVE",
      Currency: "",
      Rate: 0,
      Commisssion: 0,
    }]
  }


  returnZero() {
    return 0
  }

  searchHandler(value) {
    this.searchKey = value
  }
  searchFeedHandler(value) {
    this.searchFeed = value
  }
  get filteredGroupNames() {
    try{ 
      const searchTerm = this.searchKey || "";
      const filterGroupName : string[] = this.groupNames.filter(name => name.toLowerCase().includes(searchTerm.toLowerCase()));
      return filterGroupName;
  }catch(err){
  }
  }

  get filteredFeedNames() {
    try{ 
      const searchTerm = this.searchFeed || "";
      const filterGroupName : string[] = this.feedNames.filter(name => name.toLowerCase().includes(searchTerm.toLowerCase()));
      return filterGroupName;
      } catch(err){
    }
  }


  redirectOperatorPage = () => {
    this.router.navigate(["/administration/operators"]);
  }
  addPartnerData = () => {
    if (this.Partner[this.Partner.length - 1].PartnerId !== "" && this.Partner[this.Partner.length - 1].Currency !== "" && this.Partner[this.Partner.length - 1].Rate !== 0) {
      this.Partner.push({
        PartnerId: "",
        Status: "ACTIVE",
        Currency: "",
        Rate: 0,
        Commisssion: 0
      });
      this.AddPluseShow = true;
    }
    else {
      this.appService
        .openErrorBar("Plese Fill Current Partner Detail.");
    }
  }
  removePartnerData(i) {
    this.Partner.splice(i, 1);
    if (this.Partner[this.Partner.length - 1].PartnerId !== "" && this.Partner[this.Partner.length - 1].Currency !== "" && this.Partner[this.Partner.length - 1].Rate !== 0) {
      this.AddPluseShow = true;
    }
    else this.AddPluseShow = false;
  }
  handleChange(event, itm) {
    const { target } = event;
    const { name, value } = target;
    let cData = this.ConfigData;
    if (typeof cData[itm] === "object") {
      cData[itm][name] = value ? parseFloat(value) : "";
    }
    else
      cData[itm] = value ? parseFloat(value) : "";
    this.ConfigData = cData;
    return true;
  }


  handleChangePartner(event, index) {
    const { target } = event;
    const { name, value } = target;
    if (name === "Rate" || name === "Commisssion") {
      this.Partner[index] = { ...this.Partner[index], [name]: parseFloat(value) };
      return true;
    }

    this.Partner[index] = { ...this.Partner[index], [name]: value };
    return true;
  }


  onFormSubmit({ value, valid }: { value: OperatorData, valid: boolean }) {
    if (this.ConfigData.hold > 100) {
      return this.appService.openErrorBar("Hold should not exceed 100")
    } else {
      this.operator = value;
      let cData = this.ConfigData;
      for (let i in cData) {
        if (typeof cData[i] === "object" && cData[i].delay) {
          let d = (cData[i].delay * 1000).toFixed(1);
          cData[i] = { ...cData[i], delay: Number(d) }
        }
      }
      let postData = { ...this.operator, Partners: this.Partner, config: cData };

      try {
        this.appService.addOperators(postData).subscribe((res) => {
          if (res.status === "RS_OK") {
            this.appService.openSuccessBar("operator added successfully")
            try {
              this.dialog.open(OPUserInfoModalComponent, {
                backdropClass: "backdropBackground",
                hasBackdrop: true,
                data: {
                  userId: res.userId,
                  password: res.password,
                },
              });
            } catch (err) {}
          }
          else {
            this.appService
              .openErrorBar(res.errorDescription)
          }
        });
      } catch (err) {
        console.log("err", err)
      }

    }
  }
}
@Component({
  selector: "dialog-data-example-dialog",
  templateUrl: "./opuser-info.component.html",
  styleUrls: ["./create-operators.component.scss"],
})
export class OPUserInfoModalComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public router: Router,
  ) {}

  ngOnInit () {}

  copyText(val: string){
    let selBox = document.createElement('textarea');
      selBox.style.position = 'fixed';
      selBox.style.left = '0';
      selBox.style.top = '0';
      selBox.style.opacity = '0';
      selBox.value = val;
      document.body.appendChild(selBox);
      selBox.focus();
      selBox.select();
      document.execCommand('copy');
      document.body.removeChild(selBox);
    }

}